/* eslint-disable no-useless-escape */
export const generatePassword = (len) => {
    const length = len || 10
    const passwordArray = ["ABCDEFGHIJKLMNOPQRSTUVWXYZ", "abcdefghijklmnopqrstuvwxyz", "1234567890", '!@#$%^&*()+_-=}{[]|:;"/?.><,`~']
    const password = []
    let n = 0
    for (let i = 0; i < length; i++) {
        // If password length less than 9, all value random
        if (password.length < length - 4) {
            // Get random passwordArray index
            const arrayRandom = Math.floor(Math.random() * 4)
            // Get password array value
            const passwordItem = passwordArray[arrayRandom]
            // Get password array value random index
            // Get random real value
            const item = passwordItem[Math.floor(Math.random() * passwordItem.length)]
            password.push(item)
        } else {
            // If password large then 9, lastest 4 password will push in according to the random password index
            // Get the array values sequentially
            const newItem = passwordArray[n]
            const lastItem = newItem[Math.floor(Math.random() * newItem.length)]
            // Get array splice index
            const spliceIndex = Math.floor(Math.random() * password.length)
            password.splice(spliceIndex, 0, lastItem)
            n++
        }
    }
    return password.join("")
}

export const emailFormatCheck = (email) => {
    // eslint-disable-next-line no-useless-escape
    const reg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return reg.test(email)
}

export const camelCase = (str) => {
    return str
        .toString()
        .toLowerCase()
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase()
        })
        .replace(/\s+/g, "")
}

export const groupArray = (str, groupValue, init, extra = "") => {
    return str.reduce((acc, curr) => {
        const key = extra + camelCase(curr[groupValue])
        if (acc[key]) {
            acc[key].push(curr)
        } else {
            acc[key] = [curr]
        }
        return acc
    }, init)
}

export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

export function formatDateLocal(time) {
    const options = { year: "numeric", month: "short", day: "numeric" }
    const dateTime = new Date(time)
    const formattedDate = dateTime.toLocaleString("default", options)
    return formattedDate
}

export function detectAccountHolder(userRoles) {
    const userSortedRoles = [...userRoles]
    userSortedRoles.sort((a, b) => {
        const levelA = a.level
        const levelB = b.level
        return levelA - levelB
    })
    return userSortedRoles[0].roleName === process.env.ACCOUNT_HOLDER
}

export function detectSuperAdmin(userRoles) {
    return userRoles.length && userRoles.find((userRole) => userRole.roleName === process.env.SUPER_ADMIN)
}

export function getUserTopRole(userRoles) {
    const userSortedRoles = [...userRoles]
    userSortedRoles.sort((a, b) => {
        const levelA = a.level
        const levelB = b.level
        return levelA - levelB
    })
    const topRoleDetail = userSortedRoles[0]
    return topRoleDetail
}

export function emailFormatValidate(email) {
    const reg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!reg.test(email)) {
        return false
    }
    return true
}

export function sortObjArray(objArr, sorter) {
    const sortArr = JSON.parse(JSON.stringify(objArr))
    sortArr.sort((a, b) => {
        const elementA = a[sorter]
        const elementB = b[sorter]
        return parseInt(elementA, 10) - parseInt(elementB, 10)
    })
    return sortArr
}

export function urlPath(path, userId = undefined, participantUUIDAndToken = undefined) {
    switch (path) {
        case "super-admin-main":
            return `/super-admin`
        case "super-admin-report-ready":
            return `/super-admin/report-ready`
        case "account-holder-main":
            return `/dashboard/user/${userId}/account-holder-main`
        case "account-holder-assign-manager":
            return `/dashboard/user/${userId}/account-holder-main/assign-manager`
        case "account-holder-view-manager":
            return `/dashboard/user/${userId}/account-holder-main/view-manager`
        case "view-designation":
            return `/dashboard/user/${userId}/view-designation`
        case "view-department":
            return `/dashboard/user/${userId}/view-department`
        case "dashboard":
            return `/dashboard/user/${userId}`
        case "invitation-participant":
            return `/invitation/participant/${participantUUIDAndToken.participantUUID}?token=${participantUUIDAndToken.token}`
        case "assessment":
            return `/assessment/participant/${participantUUIDAndToken.participantUUID}?token=${participantUUIDAndToken.token}`
        case "login":
            return "/login"
        case "error-access":
            return "/error-access"
        default:
            return null
    }
}

export const getProductLink = (productId) => {
    switch (productId.toString()) {
        case process.env.PRODUCT_ID_SPARCA_ENTERPRISE:
            return process.env.PRODUCT_COMPLETE_LINK_SPARCA_ENTERPRISE
        case process.env.PRODUCT_ID_SPARCA_DATA_MANAGEMENT:
            return process.env.PRODUCT_COMPLETE_LINK_SPARCA_DATA_MANAGEMENT
        case process.env.PRODUCT_ID_SPARCA_ANALYTICAL_MATURITY:
            return process.env.PRODUCT_COMPLETE_LINK_SPARCA_ANALYTICAL_MATURITY
        case process.env.PRODUCT_ID_SPARCA_INSIGHT_ACTIVATION:
            return process.env.PRODUCT_COMPLETE_LINK_SPARCA_INSIGHT_ACTIVATION
        default:
    }
    return undefined
}

export const shuffleArray = (array) => {
    let currentIndex = array.length
    let randomIndex

    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex--
        ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
    }

    return array
}
